import styled from "styled-components";

export const StatusStyles = styled.div<any>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin: 0;
  }
`;
export const QuoteActivityPill = styled.div`
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  margin: 4px 0px;
  text-transform: uppercase;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
  float: right;
  &.open {
    background-color: #fff0d7;
    color: #a26a11;
  }
  &.pending_approval {
    background-color: #e3f2fd;
    color: var(--themeBlue900);
  }
  &.approved {
    background-color: #ccede5;
    color: #19836a;
  }
  &.rejected {
    background-color: #f8dbd9;
    color: #af1515;
  }
  &.closed {
    background-color: #f8dbd9;
    color: #af1515;
  }
  &.inprogress {
    background-color: #deebff;
    color: #0747a6;
  }
  &.success {
    background-color: #e3fcef;
    color: #006644;
  }
  &.removed {
    background-color: #ffebe6;
    color: #bf2600;
  }
  &.moved {
    background-color: #fff0b3;
    color: #172b4d;
  }
  &.requested {
    background-color: #fff0d7;
    color: #a26a11;
  }
  &.Ordered {
    background-color: #dee4f4;
    color: #11508e;
  }
  &.Partially {
    background-color: #deebff;
    color: #134c85;
  }
  &.hi {
    background: red;
  }
  &.Active {
    background-color: red;
  }
`;
